/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateless
 */
import React, { PropTypes } from 'react';
import locale from './locale'
import AttendanceScanModal from 'template/Modals/AttendanceScan'


class ModalContent extends React.Component {
  render() {
    return (
      <div className='attendance-scan-message-modal-content'>
        <h2 className='text-center'>{__('Attention Notes', locale)}</h2>
        <ul>
          <li>{__('Please make sure that the scanner is connected to the computer that is using ClasstopBase. The computer will recognize the Scanner when you plug it into a USB slot. Make sure the light on the scanner tunes on after being plugged in.', locale)}</li>
          <li>{__('When using Smart Check In and Scan Payment functions, please log in to ClasstopBase on an Administrator account with the corresponding permissions to operate these functions.', locale)}</li>
          <li>{__('Smart Check In will sign in students for a class that is about to start, or one that is already in progress (in which case the student will be marked as late). However, if the lesson has already finished, students can not sign in with Smart Check In. You can manually sign in the student in the Class Channel on ClasstopBase.', locale)}</li>
          <li>{__('When using Smart Check In and Scan Payment functions on your browser, please make sure that the corresponding window remains open, and the browser or tab is not closed, or minimized during use.', locale)}</li>
          <li>{__('Please click “I Understand” to start scanning.', locale)}</li>

          {/* <div className='text-center input-container'>
            <input type='checkbox' onClick={(e) => {
              if(e.target.checked){
                localStorage.setItem('smartScanReminder', false)
              } else {
                localStorage.setItem('smartScanReminder', true)
              }
            }} />
            <span>{__('Don’t remind me next time', locale)}</span>
          </div> */}

          <div className='text-center btn-container'>
            <button className='btn btn-primary' onClick={() => {
              this.props.dismiss()
              AttendanceScanModal()
            }}>{__('I understand', locale)}</button>
          </div>

        </ul>
      </div>
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/AttendanceScanMessage/ModalContent.js